
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import Clickoutside from 'element-ui/src/utils/clickoutside';
    import Keyboard from "@/components/Keyboard.vue"

    @Component({
        components: {Keyboard},
        directives: {Clickoutside}
    })
    export default class KeyboardInput extends Vue {
        show = false;
        @Prop() value!: string;
        GetKeyVal(val: string){
            this.changeInput(this.value + val);
            const inputEl = this.$refs.input as HTMLFormElement;
            inputEl.focus();
        }
        changeInput($event: any){
            this.$emit('input', $event);
        }
        handleClickOutside(){
            this.show = false;
        }
    }
